import { Link } from "react-router-dom";

const plans = [
  { name: "シンプル3 S", data: "5GB", price: "3,278円", call: "22円／30秒" },
  { name: "シンプル3 M", data: "30GB", price: "4,378円", call: "22円／30秒" },
  { name: "シンプル3 L", data: "35GB", price: "5,478円", call: "1回10分以内込み" },
];

const campaigns = [
  { title: "契約事務手数料", value: "オンライン3,850円", note: "9月30日までの無料キャンペーンは終了。通常の手数料を含めて計算します。" },
  { title: "SIM・eSIMのみ", value: "Sは5,000円／M・Lは15,000円相当", note: "10月1日からのMNP特典。対象の乗り換え元・データ増量オプション加入など条件あり。" },
  { title: "超！おトク割", value: "1,100円×12カ月割引", note: "シンプル3 M／Lが対象。ほかの割引と重複しない場合あり。" },
  { title: "データ増量", value: "月額550円が6カ月無料", note: "初めてデータ増量オプションへ加入する場合。" },
];

const checks = [
  "直近3カ月のデータ使用量は5GB・30GB・35GBのどこに収まるか",
  "家族割とおうち割 光セット（A）のどちらを使えるか",
  "今の端末を使うか、乗り換えと同時に購入するか",
  "乗り換え元・プラン・オプションがキャンペーン条件を満たすか",
];

export default function YmobileArticle() {
  return (
    <>
      <section id="intro">
        <p className="text-[1.08em] leading-[1.9] text-foreground-900">毎月のスマホ代を見るたびに「もう少し安くできるはず」と思う。でも、ネットだけの格安SIMへ変えて、設定に失敗したら困る。家族のスマホや端末の買い替えまで考えると、結局そのままになっていませんか。</p>
        <p>ワイモバイルは、料金を抑えながら、店舗・家族割・端末購入も残したい人が一歩を踏み出しやすい通信会社です。</p>
      </section>

      <section id="answer">
        <h2>安さと店舗の安心感を、どちらも手放したくない人へ</h2>
        <p>ワイモバイルはソフトバンクのサブブランドです。<strong>ソフトバンク回線、全国の店舗、家族向けの割引、端末販売</strong>がそろっています。最安だけを求める人より、「乗り換えた後に困りたくない人」に向いています。</p>
        <div className="not-prose my-7 overflow-hidden rounded-xl border border-background-300 bg-white">
          <div className="px-5 py-5"><span className="text-sm font-bold text-foreground-500">ワイモバイルの強み</span><strong className="mt-2 block text-2xl leading-snug text-foreground-900">店舗・家族割・端末購入・キャンペーン</strong></div>
          <div className="border-t border-background-300 bg-primary-50 px-5 py-4 text-[15px] leading-7 text-foreground-800">「安くしたい。でも全部を自分一人でやるのは怖い」という不安に応えやすい、バランス型の選択肢です。</div>
        </div>
      </section>

      <section id="price">
        <h2>料金プランは5GB・30GB・35GBの3種類</h2>
        <p>中心になるのは30GBのシンプル3 Mです。短い電話が多い人は、1回10分以内の国内通話が含まれる35GBのLも比較します。</p>
        <div className="not-prose my-7 overflow-x-auto border-y-2 border-foreground-900 bg-white">
          <table className="w-full min-w-[620px] border-collapse text-left"><thead className="bg-foreground-900 text-white"><tr><th className="px-4 py-3">プラン</th><th className="px-4 py-3">容量</th><th className="px-4 py-3">月額基本料</th><th className="px-4 py-3">国内通話</th></tr></thead><tbody>{plans.map((plan) => <tr key={plan.name} className="border-t border-background-200"><th className="px-4 py-4 text-foreground-900">{plan.name}</th><td className="px-4 py-4">{plan.data}</td><td className="px-4 py-4 font-bold">{plan.price}</td><td className="px-4 py-4">{plan.call}</td></tr>)}</tbody></table>
        </div>
        <p className="text-sm text-foreground-600">税込。端末代、超過通話料、オプション料は別途。2026年9月20日確認。</p>
        <p>公式SIMページでは2026年12月1日から月額基本料を330円増額する改定が予告されています。上の表は改定前の料金です。継続利用する場合は改定後の支払額も確認してください。家族割、おうち割 光セット（A）、PayPayカード割などを適用できる人は負担を下げられます。割引前と割引後を混ぜず、自分に使える条件だけで計算します。</p>
      </section>

      <section id="family-store">
        <h2>家族で見直せて、困ったら店舗で相談できる</h2>
        <p>一人で月1,000円下がるだけでも、家族4人なら年間4万8,000円です。ワイモバイルは家族割を使えるため、家族全員の固定費をまとめて見直しやすいのが特徴です。</p>
        <p>電話番号はそのまま使えるのか、写真やLINEは消えないか。分からないことが一つあるだけで、乗り換えを諦めてしまう人もいます。</p>
        <aside><strong>「何かあったら行ける場所がある」ことも価値です。</strong><p>全国のショップで相談できます。内容によって有料になる場合はありますが、対面窓口がある安心感はオンライン専用プランとの大きな違いです。</p></aside>
      </section>

      <section id="devices">
        <h2>乗り換えと一緒に、スマホも安く買える</h2>
        <p>SIMしか扱わない格安通信会社では、端末を別の店で探す必要があります。ワイモバイルなら、回線の乗り換えと端末購入を同時に進められます。</p>
        <p>認定中古iPhoneやAndroidには、契約方法・プランに応じた割引があります。9月の期間限定価格を現在も買える価格として扱わず、公式オンラインストアで対象機種・契約条件・現在の支払総額を確認してください。</p>
        <p>「最新機種に10万円以上は出せない。でも古すぎる端末も不安」という人には、認定中古iPhoneや割引対象のAndroidが現実的です。価格と在庫は変わるため、先に販売状況を確認します。</p>
      </section>

      <section id="iphone18">
        <h2>iPhone 18 Proは販売していない。でもワイモバイルで使える</h2>
        <p>現時点でiPhone 18 Pro本体は販売されていません。ただし、iPhone 18 Proと18 Pro MaxはワイモバイルのeSIMで利用できることが確認されています。</p>
        <div className="not-prose my-7 rounded-xl border border-background-300 bg-white p-5"><ol className="m-0 space-y-3 pl-5 text-[15px] leading-7 text-foreground-800"><li>Apple StoreなどでiPhone 18 Proを購入する</li><li>ワイモバイルではeSIMのみ申し込む</li><li>購入したiPhone 18 Proへ回線を設定する</li></ol></div>
        <p>端末代を抑えたい人は割引端末や認定中古品。最新のProモデルが欲しい人は、Appleで端末を購入してワイモバイルのeSIMを使う。この二つから選べます。</p>
      </section>

      <section id="campaigns">
        <h2>キャンペーンが多い今、自分が使える特典を全部確認する</h2>
        <p>乗り換え、SIMのみ、端末購入、自宅回線、データ増量、シニア向けなど、契約する人の状況に合わせたキャンペーンが多いことも魅力です。</p>
        <div className="not-prose my-7 divide-y divide-background-300 border-y border-background-300">{campaigns.map((campaign) => <div key={campaign.title} className="grid gap-2 py-5 md:grid-cols-[180px_210px_1fr] md:gap-5"><strong className="text-foreground-900">{campaign.title}</strong><strong className="text-primary-700">{campaign.value}</strong><span className="text-[14px] leading-7 text-foreground-600">{campaign.note}</span></div>)}</div>
        <p className="text-sm text-foreground-600">キャンペーン確認日：2026年10月5日。<a href="https://www.ymobile.jp/store/sp/sim/" target="_blank" rel="noreferrer">SIM特典の公式条件</a>と<a href="https://www.ymobile.jp/support/process/fee/" target="_blank" rel="noreferrer">事務手数料の公式案内</a>を確認しました。特典・在庫は申込み直前にも確認してください。</p>
        <p>そのほか、対象のSoftBank光とのセットでPayPayポイントがもらえる特典や、60歳以上の完全かけ放題オプションが月額1,100円永年割引になる制度もあります。</p>
        <aside><strong>大きな還元額だけで申し込まない。</strong><p>乗り換え元、対象プラン、オプション、開通期限、PayPayとの連携を確認します。複数の割引やキャンペーンを併用できない場合もあります。</p></aside>
      </section>

      <section id="before-change">
        <h2>申し込む前に、4つだけ確認</h2>
        <div className="not-prose my-7 rounded-xl border border-background-300 bg-white"><ul className="m-0 list-none p-0">{checks.map((item, index) => <li key={item} className={`flex items-start gap-3 px-4 py-4 ${index > 0 ? "border-t border-background-200" : ""}`}><span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-bold text-primary-600">{index + 1}</span><span className="text-[15px] leading-7 text-foreground-800">{item}</span></li>)}</ul></div>
      </section>

      <section id="apply">
        <h2>高いと分かっているのに、変えられない人へ</h2>
        <p>乗り換えで一番高い壁は、料金ではありません。「失敗したら困る」「家族に説明できない」「設定方法が分からない」という不安です。</p>
        <p>ワイモバイルは最安ではありません。それでも、ソフトバンク回線を利用でき、店舗で相談でき、家族の回線と端末購入までまとめて見直せます。</p>
        <p><strong>安さだけを追いかけて不安を抱えるより、安心して使い続けられる範囲で毎月の固定費を下げる。</strong>その最初の一歩として、ワイモバイルは検討する価値があります。</p>
        <div className="not-prose my-8 grid gap-3 sm:grid-cols-2"><a href="https://www.ymobile.jp/cp/" target="_blank" rel="noreferrer" className="flex items-center justify-between rounded-lg bg-primary-600 px-5 py-4 font-bold text-white hover:bg-primary-700">最新キャンペーンを確認する<span>↗</span></a><a href="https://www.ymobile.jp/store/" target="_blank" rel="noreferrer" className="flex items-center justify-between rounded-lg border border-primary-600 bg-white px-5 py-4 font-bold text-primary-700 hover:bg-primary-50">販売中のスマホを見る<span>↗</span></a></div>
        <p><Link to="/compare">ほかの通信会社と同じ条件で比較する →</Link></p>
      </section>
    </>
  );
}
